import { clone, Container, dispatcher, ingenuity, SpineBase } from "@quest/base-core";
import { FreeGameView } from "./FreeGameView";
import { eventDispatchers } from "../Constants/EventDispatchers";
import { GameParserModel } from "../Platform/GameParserModel";
import { gameConstants } from "../Constants/gameConstants";
import { SoundConstantGame } from "../Constants/SoundConstantGame";

export class FgRevealSymbolController {
  protected view: FreeGameView;
  protected revealSymbolArray: SpineBase[] = [];
  protected revealSymOffsets: number[][] = [];
  protected updatedReelGrid: number[][];

  constructor(view: FreeGameView) {
    this.view = view;
    this.init();
  }

  protected init(): void {
    this.subscribeEvents();
  }


  protected subscribeEvents(): void {
    this.unSubscribeEvents()
    dispatcher.on(eventDispatchers.FG_SHOW_REVEAL_SYMBOL, this.onShowRevealSymbol, this);
  }
  protected unSubscribeEvents(): void {
    dispatcher.off(eventDispatchers.FG_SHOW_REVEAL_SYMBOL, this.onShowRevealSymbol, this);
  }
  // Sets the flow from the creation of Layer all the way to playing the animations of the symbols on the layer and updating the static grid.

  protected onShowRevealSymbol(): void {
    this.killSymObjects();
    this.revealSymbolArray = [];
    this.updatedReelGrid = clone((ingenuity.parserModel as GameParserModel).getReelGrid());
    this.createRevealSymbolGrid();
    this.updateStaticGrid();
    this.playRevealSymbolAnimation();
  }
  // Iterates over the offset array and creates an animation layer.

  protected createRevealSymbolGrid(): void {
    this.revealSymOffsets = (ingenuity.parserModel as GameParserModel).getRevealSymOffsets();
    this.revealSymOffsets.forEach((offset) => {
      this.createAnimationLayer(offset[0], offset[1]);
      this.updatedReelGrid[offset[0]][offset[1] + gameConstants.REEL_POSITION_OFFSET] = (ingenuity.parserModel as GameParserModel).getRevealSymNum();
    }, this);
  }
  // Creates a symbol layer using reelId and Position

  protected createAnimationLayer(reelID: number, pos: number) {
    const containerID: string = gameConstants.revealReelContainer + reelID;
    const revealContainer: Container = this.view.getContainerByID(containerID);
    revealContainer.visible = true;
    const revealSymbol = (this.view as any).createRevealSpine();
    revealContainer.addChild(revealSymbol);
    revealSymbol.y = this.getRevealYPosition(pos);
    this.revealSymbolArray.push(revealSymbol);
  }
  // Plays Animation of all the symbol layers created.

  protected playRevealSymbolAnimation(): void {
    if (this.revealSymbolArray.length) {
      (ingenuity.soundManager as any).playSound(SoundConstantGame.REVEAL_ICON_TURNING, 1, false, "soundList");
    }
    for (let i = 0; i < this.revealSymbolArray.length; i++) {
      let symbol = this.revealSymbolArray[i];
      symbol.visible = true;
      symbol.playAnim("win");
      symbol.onComplete.addOnce(() => {
        symbol.visible = false;
        if (i === this.revealSymbolArray.length - 1) {
          ingenuity.configData.isRevealPresent = false;
          dispatcher.fireEvent(eventDispatchers.CHECK_AND_SHOW_NEXT_CASCADE_PRESENTATION);
        }
      });
    }
  }

  protected updateStaticGrid(): void {
    (ingenuity.parserModel as GameParserModel).setReelGrid(this.updatedReelGrid);
    this.view.getReelView().showStaticGrid((ingenuity.parserModel as GameParserModel).getReelGrid());
  }
  // Returns the Y position of the symbol based on position in the Reel. 

  protected getRevealYPosition(pos: number): number {
    return pos * 100;
  }
  // To Reset the Array every time the controller is called.

  protected killSymObjects(): void {
    this.revealSymbolArray.forEach((symObj: SpineBase) => {
      symObj.destroy();
    });
  }
}
